/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RequestReason } from './RequestReason';
import {
    RequestReasonFromJSON,
    RequestReasonFromJSONTyped,
    RequestReasonToJSON,
} from './RequestReason';

/**
 * 
 * @export
 * @interface InvestmentRequestCreatePayload
 */
export interface InvestmentRequestCreatePayload {
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequestCreatePayload
     */
    portfolioGuid: string;
    /**
     * 
     * @type {RequestReason}
     * @memberof InvestmentRequestCreatePayload
     */
    reason: RequestReason;
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequestCreatePayload
     */
    description: string;
}



/**
 * Check if a given object implements the InvestmentRequestCreatePayload interface.
 */
export function instanceOfInvestmentRequestCreatePayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "portfolioGuid" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function InvestmentRequestCreatePayloadFromJSON(json: any): InvestmentRequestCreatePayload {
    return InvestmentRequestCreatePayloadFromJSONTyped(json, false);
}

export function InvestmentRequestCreatePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentRequestCreatePayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'portfolioGuid': json['portfolio_guid'],
        'reason': RequestReasonFromJSON(json['reason']),
        'description': json['description'],
    };
}

export function InvestmentRequestCreatePayloadToJSON(value?: InvestmentRequestCreatePayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'portfolio_guid': value.portfolioGuid,
        'reason': RequestReasonToJSON(value.reason),
        'description': value.description,
    };
}

